<template>
  <div>

    <v-container fill-height fluid>

    <v-row>
      <v-flex xs3 class="mr-2 mt-6">
          <Search
            v-model="filters.search"
            :label="$t('SEARCH')"
            prepend-icon="search"
            :delay="500"
          />
      </v-flex>

      <v-flex xs2 class="mt-6">
        <PropagandistSelect
          v-model="filters.propagandist_id"
          :label="$t('fields.propagandist')"
        />
      </v-flex>

      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_from"
          :label="$t('fields.date_from')"
          :clearable="true"
        />
      </v-flex>

      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_to"
          :label="$t('fields.date_to')"
          :clearable="true"
        />
      </v-flex>


    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('manage warehouses_unload')"
        @click="showWarehouseUnloadModal(0)"
        color="primary"
        dark
        class="mt-6 mr-2"
      >{{ $t("NEW") }}
      </v-btn>

      <v-btn
        v-if="can('manage warehouses_unload')"
        @click="showWarehouseUnloadDocumentModal(0)"
        color="primary"
        dark
        class="mt-6 mr-2"
      >{{ $t("CREATE_UNLOAD_DOCUMENT") }}
      </v-btn>
      <v-btn
        v-if="can('manage warehouses_unload')"
        @click="showWarehouseUnloadScanModal(0)"
        color="primary"
        dark
        class="mt-6"
      >{{ $t("SCAN") }}
      </v-btn>
    </v-row>

    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >

      <template v-slot:item.created_at="{ item }">
            {{ item.created_at | timeFormat }}
      </template>

      <template v-slot:item.propagandist="{ item }">
            {{ item.options.propagandist }}
      </template>


      <template v-slot:item.actions="{ item }">
            <v-layout row wrap></v-layout>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchWarehouseUnload"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { warehousesService } from '../../../utils/services/warehouses.service';
  import { reportService } from '../../../utils/services/report.service';
  import WarehouseUnloadModal from '../../modals/WarehousesUnload/WarehouseUnloadModal';
  import WarehouseUnloadDocumentModal from '../../modals/WarehousesUnload/WarehouseUnloadDocumentModal.vue';
  import WarehouseUnloadScanOut from '../../modals/WarehousesUnload/WarehouseUnloadScanOut.vue';
  import Search from '../../shared/Inputs/Search.vue';
  import InputDataPicker from '../../shared/Inputs/InputDataPicker.vue';
  import PropagandistSelect from '../../shared/Vselects/PropagandistSelect.vue';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'WarehouseUnloadDetails',
    components: {
      Search,
      InputDataPicker,
      PropagandistSelect,
      Paginator,
    },
    props: {
      warehouse: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        loading: false,
        items: [],
        filters: {
          search: '',
          date_from: null,
          date_to: null,
          propagandist_id: null,
        },
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['created_at'],
        },
        headers: [
          {
            text: this.$t('fields.id'),
            align: 'left',
            value: 'id',
          },
          { text: this.$t('fields.sku'), value: 'options.sku' },
          { text: this.$t('fields.name'), value: 'options.name' },
          { text: this.$t('fields.quantity'), value: 'options.qty', sortable: false },
          { text: this.$t('fields.created_at'), value: 'created_at' },
          { text: this.$t('fields.propagandist'), value: 'propagandist', sortable: false },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
      };
    },
    computed: {
      requestFilters() {
        const filters = {};
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }

        filters.search = this.filters.search;
        filters.date_from = this.filters.date_from;
        filters.date_to = this.filters.date_to;
        filters.propagandist_id = this.filters.propagandist_id;

        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async showWarehouseUnloadModal(id) {
        this.showModal({
          component: WarehouseUnloadModal,
            data: {
              stored: {
                id,
                warehouse_id: this.warehouse.id,
              },
          },
          options: {
            title: this.$t('UNLOAD'),
            onSave: (
              form,
              error,
            ) => warehousesService.saveUnload(this.warehouse.id, form)
            .then(() => {
              this.fetchWarehouseUnload(this.pagination.page);
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchWarehouseUnload(this.pagination.page);
            }),
          },
        });
      },

      async showWarehouseUnloadScanModal(id) {
        this.showModal({
          component: WarehouseUnloadScanOut,
            data: {
              stored: {
                id,
                warehouse_id: this.warehouse.id,
              },
          },
          options: {
            title: this.$t('UNLOAD'),
            onSave: (
              form,
              error,
            ) => warehousesService.saveUnloadScan(this.warehouse.id, form)
            .then(() => {
              this.fetchWarehouseUnload(this.pagination.page);
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchWarehouseUnload(this.pagination.page);
            }),
          },
        });
      },


      downloaDocument(id) {
        return reportService.openPdf(id);
      },

      async showWarehouseUnloadDocumentModal(id) {
        this.showModal({
          component: WarehouseUnloadDocumentModal,
            data: {
              stored: {
                id,
                warehouse_id: this.warehouse.id,
              },
          },
          options: {
            title: this.$t('UNLOAD'),
            onSave: (
              form,
              error,
            ) => warehousesService.saveUnloadDocument(this.warehouse.id, form)
            .then((response) => {
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
              this.downloaDocument(response.data.pdf_id);
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchWarehouseUnload(this.pagination.page);
            }),
          },
        });
      },


      async fetchWarehouseUnload(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return warehousesService.unload(this.warehouse.id, {
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
        .then((response) => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
        })
        .catch(error => {
          this.handleError(error, this.errors);
        })
        .finally(() => {
          this.loading = false;
        });
      },
    },
    async created() {
      await this.fetchWarehouseUnload();
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchWarehouseUnload(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchWarehouseUnload(1);
          }
        },
      },
    },
  };
</script>
